var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumberValidation01 = function SvgNumberValidation01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "number_validation-01_svg2__a",
    x1: 53.5,
    x2: 193.28,
    y1: 210.49,
    y2: 70.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#number_validation-01_svg2__a",
    id: "number_validation-01_svg2__b",
    x1: 12.16,
    x2: 151.93,
    y1: 169.15,
    y2: 29.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#number_validation-01_svg2__a",
    id: "number_validation-01_svg2__c",
    x1: -27.53,
    x2: 112.24,
    y1: 129.46,
    y2: -10.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#number_validation-01_svg2__a",
    id: "number_validation-01_svg2__d",
    x1: 27.44,
    x2: 167.22,
    y1: 184.43,
    y2: 44.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#number_validation-01_svg2__a",
    id: "number_validation-01_svg2__e",
    x1: 22.64,
    x2: 162.41,
    y1: 179.63,
    y2: 39.85
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M74.33 179.32c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45h13.79c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45z",
    style: {
      fill: "url(#number_validation-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4 127.59c-2.07 0-3.45 1.38-3.45 3.45v48.62c0 7.59-6.21 13.45-13.45 13.45H42.96c-7.59 0-13.45-6.21-13.45-13.45V20.34c0-7.24 6.21-13.45 13.45-13.45h76.55c7.24 0 13.45 6.21 13.45 13.45 0 2.07 1.38 3.45 3.45 3.45s3.45-1.38 3.45-3.45C139.86 9.31 130.55 0 119.52 0H42.96C31.93 0 22.62 9.31 22.62 20.34v159.32c0 11.38 9.31 20.34 20.34 20.34h76.55c11.38 0 20.34-9.31 20.34-20.34v-48.62c0-2.07-1.38-3.45-3.45-3.45",
    style: {
      fill: "url(#number_validation-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 20.69c0-2.07-1.38-3.45-3.45-3.45H65.72c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45h31.03c2.07 0 3.45-1.38 3.45-3.45",
    style: {
      fill: "url(#number_validation-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.73 64.5c-.34-1.72-2.41-2.76-4.14-2.41v-.02c-1.72.69-2.76 2.41-2.41 4.14 5.17 18.28-5.52 37.24-23.79 42.41-18.28 5.17-37.24-5.52-42.41-23.79-5.17-18.28 5.52-37.24 23.79-42.41 2.76-.69 6.21-1.03 9.31-1.03 4.83 0 10 1.03 14.48 3.1 1.72.69 3.79 0 4.48-1.72s0-3.79-1.72-4.48c-20.69-9.66-45.52-.34-54.83 20.34-9.31 20.69-.34 45.17 20.34 54.83 20.69 9.66 45.17.34 54.83-20.34 4.14-8.97 4.83-18.97 2.07-28.62",
    style: {
      fill: "url(#number_validation-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.03 73.44c-1.38-1.38-3.45-1.38-4.83 0s-1.38 3.45 0 4.83l13.79 13.79c1.38 1.38 3.45 1.38 4.83 0l32.76-32.76c1.38-1.38 1.38-3.45 0-4.83s-3.45-1.38-4.83 0l-30.34 30.35z",
    style: {
      fill: "url(#number_validation-01_svg2__e)"
    }
  }));
};
export default SvgNumberValidation01;